import { Field } from "formik";
import React from "react";
import { Currency, Multiselect, Radio } from "../../../ui/form_fields";
import FormAccordion from "./accordion";

const BasicFields = ({ disabled, errors, fieldsData }) => {
  const { anosVencimento } = fieldsData;

  return (
    <FormAccordion
      disabled={disabled}
      title="Busca básica"
      headerId="basic-header"
    >
      <div className="">
        <Field
          name="basic.anosVencimento"
          label="Ano de vencimento"
          options={anosVencimento}
          component={Multiselect}
          fullWidth
        />
      </div>

      <div className="pt-10">
        <Field
          name="basic.valorGteq"
          label="Valor a partir de"
          component={Currency}
          error={!!errors?.valorGteq}
          helperText={errors?.valorGteq}
          fullWidth
        />
      </div>

      <div className="pt-10">
        <Field
          name="basic.valorLteq"
          label="Valor até"
          component={Currency}
          error={!!errors?.valorLteq}
          helperText={errors?.valorLteq}
          fullWidth
        />
      </div>

      <div className="pt-30">
        <Field
          label="Natureza"
          name="basic.natureza"
          options={["alimentar", "comum"]}
          component={Radio}
        />
      </div>
    </FormAccordion>
  );
};

export default BasicFields;
